/* VNMS Collective — shared behaviour (Shopify theme)
   Dark/light toggle · mobile menu · scroll reveal · interior-hero entry effect ·
   booking time-slot picker (fallback UI when no booking-app embed is configured).

   Note: cart open/close and add-to-cart are handled natively by Dawn's
   <cart-drawer> custom element (assets/cart-drawer.js) — do not duplicate that
   logic here. Language switching is native Shopify localization (URL-based,
   server-rendered), so there is no client-side string-swapping in this file. */
(function () {
  "use strict";
  var root = document.documentElement;
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------------- Theme (dark/light) ---------------- */
  var THEME_KEY = "vnms-theme";
  function applyTheme(t) {
    root.setAttribute("data-theme", t);
    document.querySelectorAll("[data-theme-label]").forEach(function (el) {
      el.textContent = el.getAttribute(t === "light" ? "data-dark-text" : "data-light-text") || el.textContent;
    });
  }
  // theme.liquid already applies any saved preference pre-paint; this just wires the toggle.
  function toggleTheme() {
    var next = root.getAttribute("data-theme") === "light" ? "dark" : "light";
    applyTheme(next);
    store.set(THEME_KEY, next);
  }

  /* ---------------- Mobile menu ---------------- */
  function openMenu() {
    var el = document.querySelector(".mobile-menu");
    var scrim = document.querySelector("[data-scrim]");
    if (el) el.classList.add("is-open");
    if (scrim) scrim.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeMenu() {
    var el = document.querySelector(".mobile-menu");
    var scrim = document.querySelector("[data-scrim]");
    if (el) el.classList.remove("is-open");
    if (scrim) scrim.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  /* ---------------- Booking time-slot picker (fallback UI) ---------------- */
  function wireSlots() {
    document.querySelectorAll("[data-slots]").forEach(function (group) {
      group.addEventListener("click", function (e) {
        var slot = e.target.closest(".slot");
        if (!slot || slot.hasAttribute("disabled")) return;
        group.querySelectorAll(".slot").forEach(function (s) { s.classList.remove("is-active"); });
        slot.classList.add("is-active");
      });
    });
  }

  /* ---------------- Scroll reveal ---------------- */
  function wireReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Interior hero: entry glitch + scroll parallax ---------------- */
  function wireHeroEffects() {
    var hero = document.querySelector(".page-hero");
    if (!hero || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) return;

    hero.classList.add("is-entering");
    window.setTimeout(function () { hero.classList.remove("is-entering"); }, 920);

    var ticking = false;
    function updateParallax() {
      var rect = hero.getBoundingClientRect();
      var shift = Math.max(-72, Math.min(72, -rect.top * 0.14));
      hero.style.setProperty("--hero-parallax", shift + "px");
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
    updateParallax();
  }

  /* ---------------- Wire up on ready ---------------- */
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-toggle-theme]").forEach(function (b) { b.addEventListener("click", toggleTheme); });
    document.querySelectorAll("[data-open-menu]").forEach(function (b) { b.addEventListener("click", openMenu); });
    document.querySelectorAll("[data-close-menu]").forEach(function (b) { b.addEventListener("click", closeMenu); });
    var scrim = document.querySelector("[data-scrim]");
    if (scrim) scrim.addEventListener("click", closeMenu);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });
    document.querySelectorAll(".mobile-menu a").forEach(function (a) { a.addEventListener("click", closeMenu); });

    wireSlots();
    wireReveal();
    wireHeroEffects();
  });

  /* Sections added/reordered live in the theme editor are injected via AJAX
     (no full page reload), so DOMContentLoaded never fires again for them —
     re-wire reveal-on-scroll whenever Shopify loads/reorders a section, or
     data-reveal elements added after the initial page load stay stuck at
     opacity:0 forever (only their non-gated .ghost backdrop stays visible). */
  document.addEventListener("shopify:section:load", wireReveal);
  document.addEventListener("shopify:section:reorder", wireReveal);
})();
